



























































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";
import { IBasketRoute } from "@/models/baskets";

@Component({
  components: {
    "client-footer": () => import("@/skeleton/client/clientFooter.vue"),
    "basket-topper": () =>
      import("@/components/app/global/baskets/basket/basketTopper.vue"),
    "basket-notifications": () =>
      import("@/components/app/global/baskets/basket/basketNotifications.vue"),
    "basket-stepper": () =>
      import("@/components/app/global/baskets/basket/basketStepper.vue"),
    "basket-button": () =>
      import("@/components/app/global/baskets/basket/basketButton.vue"),
    "basket-currency-switcher": () =>
      import(
        "@/components/app/global/baskets/basket/basketCurrencySwitcher.vue"
      )
  }
})
export default class BasketSteppedView extends Mixins(Context) {
  // Inject

  @Inject({ from: "basketProviderData" })
  public $basketData!: () => IBasketProviderData;

  public get basketData() {
    return this.$basketData();
  }

  // Props

  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];
}
